export default function Faq({ question, answer }) {
    return (
        <div className="w-full flex flex-col rounded border p-4">
            <h3 className="font-semibold">{question}</h3>
            <div className="text-sm text-gray-600 mt-1">{answer}</div>
        </div >
    )
}